import SelectInput from './SelectInput.vue';

export default SelectInput;
